import React, { useContext, useEffect } from "react";
import { Drawer } from "antd";
import { useMediaQuery } from "react-responsive";
import { useLocation } from "react-router-dom";
import { QueueContext } from "../../context/QueueProvider";
import { theme } from "../../globalStyles";
import Player from "./";
import HelmetWrapper from "../HelmetWrapper";
import { EditorContext } from "../../editor/context/EditorContext/EditorProvider";
import { DrawerContainer } from "./styles";

const PlayerContainer = () => {
  const queue = useContext(QueueContext);
  const editor = useContext(EditorContext);

  // see if we should spawn editor drawer (demo) from GET params
  const queryString = useLocation().search;
  useEffect(() => {
    const searchParams = new URLSearchParams(queryString);
    if (searchParams.get("spawnEditor") && searchParams.has("trackId")) {
      const trackId = searchParams.get("trackId");
      const demo = searchParams.get("demo");
      editor.requestTrackIdOpen(trackId, true, demo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isMobile = useMediaQuery({ maxWidth: theme.breakpoints.mobile });

  const location = useLocation();
  const browsePaths = ["/", "/browse", "/browse/"];
  const shouldMakeSpaceForFilters = browsePaths.includes(location.pathname);

  return (
    queue.playlist.length > 0 && (
      <HelmetWrapper>
        <DrawerContainer>
          <Drawer
            height={theme.playerDrawer.height}
            placement="bottom"
            getContainer={false}
            mask={false}
            className="player-drawer"
            title={null}
            closable={false}
            destroyOnClose={false}
            visible={!editor.drawerState.visible}
            zIndex={998}
            style={{
              left:
                shouldMakeSpaceForFilters && !isMobile ? theme.sidebar.width : 0
            }}
          >
            <Player showTrackDetails={!shouldMakeSpaceForFilters} />
          </Drawer>
        </DrawerContainer>
      </HelmetWrapper>
    )
  );
};

export default PlayerContainer;
